import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Axios from "axios";
import { config } from "@/config/constants.js";
import "@/config/validation";
import { setInteractionMode } from "vee-validate";
import "@/util/functions";

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.prototype.$http = Axios;

const token = localStorage.getItem(config.token_key);
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

setInteractionMode("lazy");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

